
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Sidebar = () => {
  const { user } = useAuth();
  const location = useLocation();

  // Define menu items based on user role
  const getMenuItems = () => {
    if (!user) return [];

    switch (user.role) {
      case 'admin':
        return [
          { name: 'Dashboard', path: '/admin/dashboard', icon: '🏠' },
          { name: 'Notices', path: '/admin/notices', icon: '📢' },
          { name: 'Students', path: '/admin/students', icon: '🎓' },
          { name: 'Teachers', path: '/admin/teachers', icon: '👨‍🏫' },
          { name: 'Results', path: '/admin/results', icon: '📊' },
          { name: 'Admissions', path: '/admin/admissions', icon: '📝' },
          { name: 'Gallery', path: '/admin/gallery', icon: '🖼️' },
          { name: 'Users', path: '/admin/users', icon: '👥' },
          { name: 'Settings', path: '/admin/settings', icon: '⚙️' },
        ];
      case 'teacher':
        return [
          { name: 'Dashboard', path: '/teacher/dashboard', icon: '🏠' },
          { name: 'Profile', path: '/teacher/profile', icon: '👤' },
          { name: 'Classes', path: '/teacher/classes', icon: '📚' },
          { name: 'Students', path: '/teacher/students', icon: '🎓' },
          { name: 'Attendance', path: '/teacher/attendance', icon: '✅' },
          { name: 'Marks', path: '/teacher/marks', icon: '📈' },
          { name: 'Materials', path: '/teacher/materials', icon: '📖' },
          { name: 'Change Password', path: '/teacher/change-password', icon: '🔒' },
        ];
      case 'student':
        return [
          { name: 'Dashboard', path: '/student/dashboard', icon: '🏠' },
          { name: 'Profile', path: '/student/profile', icon: '👤' },
          { name: 'Attendance', path: '/student/attendance', icon: '✅' },
          { name: 'Results', path: '/student/results', icon: '📊' },
          { name: 'Admit Card', path: '/student/admit-card', icon: '🎫' },
          { name: 'Change Password', path: '/student/change-password', icon: '🔒' },
        ];
      default:
        return [];
    }
  };

  const menuItems = getMenuItems();

  return (
    <div className="bg-white shadow-md h-full w-64 fixed left-0 top-16 bottom-0 overflow-y-auto z-10">
      <div className="p-4 border-b">
        <h2 className="text-xl font-bold text-primary capitalize">
          {user?.role} Panel
        </h2>
        <p className="text-sm text-gray-600 truncate">{user?.name}</p>
      </div>
      
      <nav className="mt-4">
        <ul>
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`flex items-center px-6 py-3 text-base font-medium transition-colors duration-200 ${
                  location.pathname === item.path
                    ? 'text-white bg-primary'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <span className="mr-3 text-lg">{item.icon}</span>
                <span>{item.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;